import React from 'react';

// Styles
import styles from './style.module.scss';

interface TypographyProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'label';
  ref?: React.RefObject<HTMLElement | null>;
}

const Typography = ({ children, className, variant = 'p', ref }: TypographyProps) => {
  const style = `${styles.typography} ${styles[variant]} ${className}`;
  const props = {
    className: style,
    ref: ref,
  }
  switch (variant) {
    case 'h1':
      return <h1 {...props}>{children}</h1>;
    case 'h2':
      return <h2 {...props}>{children}</h2>;
    case 'h3':
      return <h3 {...props}>{children}</h3>;
    case 'h4':
      return <h4 {...props}>{children}</h4>;
    case 'h5':
      return <h5 {...props}>{children}</h5>;
    case 'h6':
      return <h6 {...props}>{children}</h6>;
    case 'p':
      return <p {...props}>{children}</p>;
    case 'span':
      return <span {...props}>{children}</span>;
    case 'label':
      return <label {...props}>{children}</label>;
  }
};

export default Typography;
